<template>
  <!-- grid -->
  <section
    class="users-not-on-site-table users-not-on-site-white-bg-sec"
    style="background-color: white"
  >
    <PrintBadgeForm :selectedUsersForPrint="usersForPrint" />
    <div>
      <h6 class="hint-grid">
        {{
          $t("common.notes.usersNotOnSite", {
            time: data.reportDate,
            site: data.sitesString,
          })
        }}
        <!-- {{ data.reportDate }} on {{ data.sitesString }}. -->
      </h6>
    </div>

    <DxDataGrid
      id="gridUsersNotOnSiteData"
      :data-source="rowsData"
      :ref="dataGridRefName"
      :remote-operations="false"
      :showBorders="false"
      :columnAutoWidth="true"
      :allowColumnReordering="true"
      :allowColumnResizing="true"
      :rowAlternationEnabled="false"
      :showColumnLines="true"
      :showRowLines="true"
      :two-way-binding-enabled="true"
      :no-data-text="'No users found'"
      :class="{
        notOnSiteGridHeightWithAlert: getActiveSessionsCount,
        notOnSiteGridHeight: !getActiveSessionsCount,
      }"
      @editor-preparing="onEditorPreparing($event)"
      @content-ready="contentReady($event)"
      @data-error-occurred="onDataErrorOccurred($event)"
      :rtl-enabled="rtlEnabled"
    >
      <DxScrolling mode="standard" :scroll-by-content="rtlEnabled" :use-native="!rtlEnabled" />
      <DxPaging :page-size="50" />
      <DxPager
        :visible="true"
        :allowed-page-sizes="[50, 100, 150, 200]"
        :display-mode="'full'"
        :show-page-size-selector="true"
        :show-info="true"
        :show-navigation-buttons="true"
        :infoText="rtlEnabled ?  'صفحة {0} من {1} ({2} إجمالي العناصر)' : ''"
        />

      <DxStateStoring
        :enabled="true"
        type="custom"
        :customSave="customSave"
        :customLoad="customLoad"
      />

      <DxFilterRow :visible="true" />

      <DxHeaderFilter :visible="true" />

      <DxColumnChooser
        :enabled="true"
        mode="select"
        :title="$t('common.grid.columnChooser')"
      />

      <DxToolbar>
        <DxItem location="before" template="columnButtonTemplate" />
        <DxItem location="before" template="exportButtonTemplate" />
        <DxItem location="before" template="clearAllTemplate" />
      </DxToolbar>

      <DxColumn
        data-field="fullName"
        :caption="$t('common.fullName')"
        :allow-header-filtering="false"
        :filter-operations="allowedOperations"
        :visible="true"
        :width="200"
        data-type="string"
      />

      <DxColumn
        :caption="$t('common.userType')"
        data-field="userType"
        :allow-editing="false"
        :visible="true"
        :filter-operations="allowedOperations"
        :allow-filtering="false"
        :allow-header-filtering="true"
        data-type="string"
      />

      <DxColumn
        data-field="email"
        :caption="$t('common.email')"
        :allow-header-filtering="false"
        :filter-operations="allowedOperations"
        :visible="true"
        :width="200"
        data-type="string"
      />

      <DxColumn
        data-field="phone"
        :caption="$t('common.phoneNumber')"
        :allow-header-filtering="false"
        :filter-operations="allowedOperations"
        :visible="true"
        data-type="string"
      />

      <DxColumn
        data-field="rfid"
        caption="RFID"
        :allow-header-filtering="false"
        :filter-operations="allowedOperations"
        :visible="true"
        data-type="string"
        :min-width="150"
        :allow-sorting="false"
        cell-template="rfid-template"
      />

      <template #rfid-template="{ data }">
        {{ data.data.rfid ? data.data.rfid : " - " }}
      </template>

      <DxColumn
        data-field="user_user_id"
        :caption="$t('common.id')"
        :allow-header-filtering="false"
        :filter-operations="allowedOperations"
        :allow-editing="false"
        :visible="false"
        data-type="string"
      />

      <DxColumn
        data-field="actions"
        :caption="$t('common.grid.action')"
        :allow-filtering="false"
        :allow-exporting="false"
        :allow-editing="false"
        :visible="true"
        :allow-sorting="false"
        cell-template="signin-action-cell"
        data-type="object"
      />

      <template #signin-action-cell="{ data }">
        <b-button
          v-b-modal="'dashboardActionOne'"
          @click="setSignInModalData(data)"
          class="d-flex align-items-center text-center usersNotOnSite-signin-btn custom-action-grid"
          >{{ $t("common.signIn") }}
        </b-button>
      </template>

      <template #exportButtonTemplate>
        <DxDropDownButton
          class="export-dropdown"
          :items="buttonData"
          :text="$t('common.grid.export')"
          @item-click="onItemClick"
        />
      </template>

      <template #columnButtonTemplate>
        <button class="custom-columns" @click="dataGrid.showColumnChooser()">
          <span class="custom-text">{{ $t("common.grid.columns") }} </span>
          <span class="custom-icon">
            <i class="dx-icon dx-icon-spindown dx-icon-right"></i>
          </span>
        </button>
      </template>

      <template #clearAllTemplate>
        <div v-if="showClearAll" class="clear-cols d-flex align-items-center">
          <div class="toolbar-custom-line"></div>
          <Button
            :text="$t('common.grid.clearFilters')"
            @click="reset()"
            styling-mode="outlined"
            type="danger"
            class="clear-CustomColums"
          />
        </div>
      </template>
    </DxDataGrid>

    <!-- sign in user  -->
    <b-modal
      id="dashboardActionOne"
      hide-footer
      hide-header
      size="md"
      :scrollable="true"
    >
      <UserCheckinAction
        :parentGrid="'notOnSite'"
        @refreshNotOnSiteGrid="refreshGridOnConfirmingModal"
        @printBadge="printBadge"
      />
    </b-modal>
  </section>
</template>

<script>
const dataGridRefName = "dataGridUsersNotOnSiteData";
// import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import { usersNotOnSiteColumns } from "@/utils/dataSource";
import "jspdf-autotable";
import { default as Button } from "devextreme-vue/button";
import { exportDataGrid } from "devextreme/excel_exporter";
import { exportDataGrid as exportDataGridToPdf } from "devextreme/pdf_exporter";
import { cloneDeep } from 'lodash';
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { jsPDF } from "jspdf";
import UserCheckinAction from "@/components/sharedCells/userAction/UserCheckinAction";
import { rfidFormatterMixin } from "@/utils/mixins/rfidFormatterMixin";
import {font as AmiriFont} from "./Amiri-Regular-normal.js";
import PrintBadgeForm from "@/router/views/dailylogUsersMassaction/printBadgeForm.vue";
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxHeaderFilter,
  DxColumnChooser,
  DxToolbar,
  DxItem,
  DxStateStoring,
  DxScrolling,
  DxPaging,
  DxPager,
} from "devextreme-vue/data-grid";

export default {
  name: "usersNotOnSiteGrid",
  title: "Users not on site",
  components: {
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxHeaderFilter,
    DxColumnChooser,
    DxToolbar,
    DxItem,
    DxDropDownButton,
    DxStateStoring,
    Button,
    DxScrolling,
    DxPaging,
    DxPager,
    UserCheckinAction,
    PrintBadgeForm
  },
  props: ["data", "sitesIds", "userTypesIds"],
  mixins: [rfidFormatterMixin],
  data() {
    return {
      dataGridRefName,
      allowedOperations: ["contains"],
      selectedOperation: "contains", // default icon
      buttonData: ["Excel", "CSV", "PDF"],
      usersNotOnSiteColumns: usersNotOnSiteColumns,
      showClearAll: false,
      regenerateStatus: false,
      rtlEnabled: false,
      usersForPrint: [],
    };
  },
  methods: {
    ...mapActions("grid", [
      "onTableHeader",
      "updateTableHeaders",
      "createTableHeaders",
      "exportJobBE",
      "onSetLoading",
    ]),
    ...mapActions("modal", ["setData"]),
    ...mapActions("reports", ["fetchUsersNotOnSite"]),
    setSignInModalData(data) {
      console.log("userData", data.data);
      Object.assign(data.data, { sitesIds: this.sitesIds });
      this.setData(data.data);
    },
    printBadge(val) {
      this.usersForPrint = val;
      setTimeout(() => {
        this.printPage();
      }, 500);
    },
    printPage() {
      const printContent = document.getElementById("multi-print-area").innerHTML;
      const printWindow = window.open("", "", "width=800,height=600");

      const html = `
        <html>
          <head>
            <link href="https://fonts.googleapis.com/css2?family=Lato&display=swap" rel="stylesheet" onload="this.loaded=true">
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/all.min.css" onload="this.loaded=true">
            <style>
              ${this.getPrintStyles()}
            </style>
            <scr` + `ipt>
              function waitForResources() {
                const links = document.querySelectorAll('link[rel="stylesheet"]');
                const allLoaded = Array.from(links).every(l => l.loaded);
                if (allLoaded) {
                  window.print();
                  window.close();
                } else {
                  setTimeout(waitForResources, 50);
                }
              }
            </scr` + `ipt>
          </head>
          <body onload="waitForResources()">
            ${printContent}
          </body>
        </html>
      `;

      printWindow.document.write(html);
      printWindow.document.close();
    },
    getPrintStyles() {
        return `
          @media print {
            body {
              zoom: 2; /* Scale content 2x (200%) */
            }
          }
          body {
            font-family: 'Lato';
          }
          .multi-print-page {
            width: 255px;
            color: #000000;
            position: relative;
            padding: 5px 10px;
            padding-bottom: 0;
            text-align: start;
            min-height: 48vh;
          }
          .multi-print-text {
            font-size: 9px;
            font-weight: 700;
            position: relative;
            z-index: 1;
            line-height: 1.2;
          }
          .multi-watermark {
            position: absolute;
            font-size: 48px;
            color: rgba(0, 0, 0, 0.1);
            z-index: 0;
            pointer-events: none;
            white-space: nowrap;
          }
          .logo-watermark {
            top: 0;
            inset-inline-start: 20%;
          }
          .entity-watermark {
            top: 12%;
            inset-inline-start: 50%;
            transform: translate(-50%, -50%) rotate(-45deg);
          }
          
          .img-watermark {
            opacity: 15%;
            max-height: 121px;
            max-width: 78px;
            width: auto;
          }
          
          .qr-border {
            border: 3px solid black;
            padding: 3px;
            border-radius: 5px;
            max-width: 54px;
            width: 54px;
            height: 54px;
            position: relative;
            z-index: 1;
          }
          .qr-img {
            max-width: 53px;
            width: 53px;
            height: 53px;
          }
          .user-img {
            border-radius: 5px;
            width: 64px !important;
            height: 64px !important;
          }

          .sections {
            display: flex;
            flex-direction: column;
            gap: 7px;
          }

          .section1 {
              display: flex;
          }

          .section1.noPhotoNoQr {
            justify-content: center;
          }

          .section1.withPhotoQr, .section1.qrOnly {
              justify-content: space-between;
          }

          .section1.photoOnly {
              gap: 8px
          }

          .section1-text.noPhotoNoQr, .section1-text.withPhotoQr {
            text-align: center;
          }

          .section1-text,
          .section2 {
            display: flex;
            flex-direction: column;
            .multi-print-text-without-fields {
              margin-bottom: 8px;
            }
            .multi-print-text-with-fields {
              margin-bottom: 8px;
            }
          }

          .section1-text {
            height: 64px;
            justify-content: space-between;
          }

          .section2 {
            min-height: 60px;
            justify-content: center;
          }

          .section2.noPhotoNoQr {
              text-align: center;
          }

          .section3 {
              text-align: center;
              gap: 11px;
              display: flex;
              flex-direction: column;
          }

          .nowrap {
            white-space: nowrap;
          }

          .badge-separator {
            border-top: 0.75px solid #000000;
            margin-bottom: 8px;
          }

          .badge-section {
              height: 30px;
          }

          .badges {
              display: flex;
              flex-wrap: wrap;
              font-size: 9px;
              align-items: center;
            }

          .badge-block {
              display: flex;
              align-items: center;
              gap: 3px;
              flex: 0 0 50%;
          }

          .badge-icon {
            width: 15px;
            height: 15px;
            background: #000000;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
          }
        `;
      },
    async customLoad() {
      if (this.userEmail !== "lt_techteam@visipoint.com") {
        await this.onTableHeader({
          url: "/users-not-on-site",
        });
        let value = this.getTableHeaders;
        console.log("customLoad");
        console.log(value);
        return value;
      }
    },
    customSave(gridState) {
      if (this.userEmail !== "lt_techteam@visipoint.com") {
        gridState.pageIndex = 0;
        gridState.pageSize = 500;
        let value = JSON.stringify(gridState);
        value = value.replace(',"selectedRowKeys":[]', "");

        if (!this.getTableHeaders) {
          this.createTableHeaders({
            url: "/users-not-on-site",
            headers: value,
            filters: "[]",
          });
        } else if (value != JSON.stringify(this.getTableHeaders)) {
          this.updateTableHeaders({
            url: "/users-not-on-site",
            headers: value,
            filters: "[]",
          });
        }
        console.log(
          "customSave value",
          value != JSON.stringify(this.getTableHeaders)
        );
      }
    },
    fetchTableHeaders() {
      this.onTableHeader({
        url: "/users-not-on-site",
        headers: usersNotOnSiteColumns,
      });
    },
    onToggleVisible() {
      this.$bvModal.show("emergencyListColumns");
    },
    contentReady(e) {
      let sortedExp = this.getSortedColumns();
      let filterExp = e.component.getCombinedFilter();
      if (filterExp || sortedExp) {
        this.showClearAll = true;
      } else {
        this.showClearAll = false;
      }
      this.setColumnChooserPosition();
    },
    getSortedColumns() {
      let allColumns = Array.from(
        Array(this.dataGrid.columnCount()).keys()
      ).map((index) => this.dataGrid.columnOption(index));
      allColumns = allColumns.find((col) => col.sortIndex != null);
      return allColumns;
    },
    setColumnChooserPosition() {
      var columnChooserView = this.dataGrid.getView("columnChooserView");
      if (!columnChooserView._popupContainer) {
        columnChooserView._initializePopupContainer();
        columnChooserView.render();
      }
      columnChooserView._popupContainer.option("position", {
        of: this.dataGrid.element(),
        my: this.getLanguage === "en" ? "left top" : "right top",
        at: this.getLanguage === "en" ? "left top" : "right top",
        offset: "0 50",
      });
    },
    onEditorPreparing(e) {
      if (e.parentType == "filterRow") {
        e.editorOptions.placeholder = this.$t("common.grid.search");
      }
    },
    serverSideExport(e) {
      // console.log(e);
      const columnNames = this.dataGrid.getVisibleColumns();
      const columns = [];
      for (let i = 0; i < columnNames.length; i++) {
        if (columnNames[i].allowExporting) {
          columns.push(columnNames[i].caption);
        }
      }
      this.exportJobBE({
        type: e.itemData,
        headers: columns.reduce((accumulator, value) => {
          return { ...accumulator, [value]: value };
        }, {}),
        gridName: "emergencySession",
        emergency_session_id: this.id,
        entity_id: this.currentEntity.id,
        filterBy: {},
        orderBy: {
          sortField: null,
          sortOrder: null,
        },
      });
    },
    async onItemClick(e) {
      if (e.itemData == "Excel") {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");
        exportDataGrid({
          component: this.dataGrid,
          worksheet: worksheet,
          customizeCell: function (options) {
            const excelCell = options;
            excelCell.font = { name: "Arial", size: 12 };
            excelCell.alignment = { horizontal: "left" };
          },
        }).then(function () {
          workbook.xlsx.writeBuffer().then(function (buffer) {
            saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              "users-not-on-site.xlsx"
            );
          });
        });
        // e.cancel = true;
      } else if (e.itemData == "CSV") {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");
        const currentLanguage = this.getLanguage

        exportDataGrid({
        component: this.dataGrid,
        worksheet: worksheet,
        customizeCell: function (options) {
            const excelCell = options;
            excelCell.font = { name: "Arial", size: 12 };
            excelCell.alignment = { horizontal: currentLanguage == 'ar'?"right":"left" };
        }
        }).then(function () {
        workbook.csv.writeBuffer().then(function (buffer) {
            const utf8BOM = new Uint8Array([0xEF, 0xBB, 0xBF]);
            const csvData = new Blob([utf8BOM, buffer], { type: "text/csv;charset=utf-8;" });
            saveAs(csvData, "users-not-on-site.csv");
        });
      });
      } else if (e.itemData == "PDF") {
        const currentLanguage = this.getLanguage
        const doc = new jsPDF("landscape");

        doc.addFileToVFS("Amiri-Regular.ttf", AmiriFont);
        doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");

        const newInstanceDataGrid = cloneDeep(this.dataGrid)
        const reversedColumns = newInstanceDataGrid.option("columns").reverse();
        newInstanceDataGrid.option('columns', reversedColumns)     


        // let columns = this.dataGrid.getVisibleColumns();

        // if (currentLanguage === "ar") {
        //   console.log("AR LANG")
        //     columns = [...columns].reverse();
        // }

        // const reversedColumns = this.dataGrid.option("columns").reverse();
        // this.dataGrid.option('columns',reversedColumns)
        exportDataGridToPdf({
          jsPDFDocument: doc,
          component: newInstanceDataGrid,
          customizeCell: function (options) {
            const { gridCell, pdfCell } = options;

            if (gridCell.rowType === "data") {
              // data columns style
              pdfCell.styles = {
                font: currentLanguage === "ar" ? "Amiri" : "times",
                fontStyle: "lato",
                fontSize: 8,
                cellWidth: "auto",
              };
            } else {
              // header columns style
              if(currentLanguage === 'ar'){
                doc.setFont("Amiri")
                pdfCell.styles = {
                font:  "Amiri",
                fontStyle: "lato",
                fontSize: 8,
                fillColor: "#2680EB",
                textColor: "#FFFFFF",
                cellWidth: "auto",
              };
              }else{
                pdfCell.styles = {
                font:  "times",
                fontStyle: "lato",
                fontSize: 8,
                fillColor: "#2680EB",
                textColor: "#FFFFFF",
                cellWidth: "auto",
                };
              }
            }
          },
        }).then(() => {
          const pageCount = doc.internal.getNumberOfPages();
          for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            const pageSize = doc.internal.pageSize;
            const pageWidth = pageSize.width
              ? pageSize.width
              : pageSize.getWidth();
            const pageHeight = pageSize.height
              ? pageSize.height
              : pageSize.getHeight();
            const header = this.$t('common.usersNotOnSite');
            const headerWidth = doc.getTextDimensions(header).w;
            const footer = `${this.$t('common.page')} ${i} ${this.$t('common.of')} ${pageCount}`;

            // Header
            doc.text(header, (pageWidth - headerWidth) / 2, 10);

            // Footer
            doc.text(
              footer,
              pageWidth / 2 - doc.getTextWidth(footer) / 2,
              pageHeight - 5,
              { baseline: "bottom" }
            );
          }

          doc.save("users-not-on-site.pdf");
        });
      }
    },
    reset() {
      console.log("reset grid ");

      this.dataGrid.clearFilter("row");
      this.dataGrid.clearFilter("header");
      this.dataGrid.clearSorting();
      this.showClearAll = false;
    },
    refreshGridOnConfirmingModal() {
      this.$emit("refreshGrid");
    },
    onDataErrorOccurred(e) {
      console.log("onDataErrorOccurred e", e);
      setTimeout(() => {
        let errorRow = document.querySelector(
          ".dx-datagrid-headers .dx-error-message"
        );
        errorRow.innerHTML = this.$t("common.notes.anErrorOccurredGrid");
      }, 100);
    },
  },
  watch: {
    getTableHeaders(value) {
      console.log("watch", value);
    },
    regenerateStatus(value) {
      console.log("regenerate valueeeeeeeeeee", value);
      if (value) {
        setTimeout(() => {
          this.reset();
        }, 800);
      }
    },
  },
  computed: {
    ...mapGetters("grid", [
      "getTableHeaders",
      "getTableFilters",
      "getExportProgessAppearance",
      "getVaccinePCRColumnAppearance",
    ]),
    ...mapGetters("authfack", ["userDetails", "currentEntity"]),
    ...mapGetters("emergency", ["getActiveSessionsCount"]),
    ...mapGetters("i18N", ["getLanguage"]),
    rowsData() {
      return this.data.users && this.data.users.length > 0
        ? this.data.users.map((row) => {
            return {
              user_id: row.user_id,
              user_user_id: row.user_user_id,
              fullName:
                row.fullName && row.fullName != null ? row.fullName : "-",
              phone: row.phone && row.phone != null ? row.phone : "-",
              userType:
                row.user_type_name && row.user_type_name != null
                  ? row.user_type_name
                  : "-",
              company:
                row.company_name && row.company_name != null
                  ? row.company_name
                  : "-",
              email: row.email && row.email != null ? row.email : "-",
              rfid: row?.user?.rf_ids?.length
                ? this.rfidFormatter(row.user.rf_ids)
                : null,
              vehicleRegistration:
                row.vehicle_registration && row.vehicle_registration != null
                  ? row.vehicle_registration
                  : "-",
              user_type_id: row.user_type_id ?? null,
              first_name: row.first_name ?? null,
              last_name: row.last_name ?? null,
              profile_image: row.image,
            };
          })
        : [];
    },
    dataGrid() {
      return this.$refs[this.dataGridRefName].instance;
    },
    userEmail() {
      return this.userDetails && this.userDetails.email;
    },
  },
  created() {
    // console.log('dataGrid',this.data);
    this.regenerateStatus = this.data.regenerate;
    document.addEventListener("mousedown", (e) => {
      if (e.path) {
        let isColumnChooser = false;
        for (let i = 0; i < e.path.length; i++) {
          if (typeof e.path[i].matches == "function") {
            if (e.path[i].matches(".dx-overlay-content")) {
              isColumnChooser = true;
            }
          }
        }
        if (!isColumnChooser) this.dataGrid.hideColumnChooser();
      }
    });
  },
  beforeMount() {
    if (this.getLanguage == "ar") {
      this.rtlEnabled = true;
    }
  },
};
</script>

<style lang="scss" scoped>
button.btn.d-flex.align-items-center.text-center.usersNotOnSite-signin-btn.btn-secondary.dx-template-wrapper {
  display: flex;
  background: #2680eb;
  border-radius: 12.5px;
  display: flex;
  justify-content: center;
  border: none;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #ffffff;
}

p {
  font-size: 12px;
  color: #b9b7b7;
}

.users-not-on-site-table {
  tbody {
    color: #495057;
  }
}
</style>

<style lang="scss">
.notOnSiteGridHeight .dx-datagrid {
  height: calc(100vh - 231px);
}
.notOnSiteGridHeightWithAlert .dx-datagrid {
  height: calc(100vh - 277px);
}
.users-not-on-site-white-bg-sec {
  background-color: white;
  padding-inline-start: 0px;
  border-radius: 8px !important;
}

[aria-label="Column RFID"] {
  .dx-sort.dx-sort-up,
  .dx-sort.dx-sort-down {
    display: none !important;
  }
}
</style>
